import { Block } from '../../factories/types';
import { ButtonWrapper } from './ButtonWrapper';

export const Button: Block<'button'> = ({ data }) => (
	<ButtonWrapper data={data} />
);
